//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReviewSharingOption } from './Enums';

export class PublicReviewDisplayItem extends ItemBase {
    ID: string | null = null;
    SchoolID: string | null = null;
    TeacherID: string | null = null;
    ParentID: string | null = null;
    CreatedDate: string = "1970-01-01T00:00:00";
    RatingPercentage: number = 0;
    ReviewBody: string | null = null;
    ParentFirstName: string | null = null;
    ParentLastName: string | null = null;
    SharingOption: ReviewSharingOption = ReviewSharingOption.AdminOnly;

    constructor(initializer?: Partial<PublicReviewDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PublicReviewDisplayItem";
}
